import { mapToApiServiceType } from './serviceTypeMapper';
import { mapToApiVehicleId } from '../sharedVehicleMappers';
import { mapToApiCollectedAccessories } from './accessoriesMapper';
import {
    ServiceOrderCompletion,
    ServiceOrderStartInfo,
} from '../../../serviceOrders/serviceOrders/serviceOrderExecution.types';
import {
    ApiServiceOrderCompletion,
    ApiServiceOrderStartInfo,
} from '../../types/serviceOrder/serviceOrderExecutionApi.types';

export const mapToApiServiceOrderStartInfos = (startInfo: ServiceOrderStartInfo): ApiServiceOrderStartInfo => ({
    type: mapToApiServiceType(startInfo.type),
    vehicle_id: mapToApiVehicleId(startInfo.vehicleId),
    started_at: startInfo.startedAt.toISOString(),
    general_information: startInfo.generalInformation,
    collected_accessories:
        startInfo.collectedAccessories !== undefined
            ? mapToApiCollectedAccessories(startInfo.collectedAccessories)
            : undefined,
});

export const mapToApiServiceOrderCompletion = (completion: ServiceOrderCompletion): ApiServiceOrderCompletion => ({
    type: mapToApiServiceType(completion.type),
    vehicle_id: mapToApiVehicleId(completion.vehicleId),
    started_at: completion.startedAt !== undefined ? completion.startedAt.toISOString() : undefined,
    completed_at: completion.completedAt.toISOString(),
    general_information: completion.generalInformation,
    collected_accessories:
        completion.collectedAccessories !== undefined
            ? mapToApiCollectedAccessories(completion.collectedAccessories)
            : undefined,
});
